import _ from 'lodash';

import createModel, { prop } from 'models/lib/create_model';
import HitTypes from 'models/search/hit_types';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import SearchAggregations from 'models/search/search_aggregations';
import searchHitFromJs from 'models/search/search_hit_from_js';
import SearchQuery from 'models/search/search_query';
import ServerClock from 'scripts/application/lib/server_clock';

export default createModel({
  modelName: 'SearchResult',

  properties: {
    id: prop(String).isRequired,
    requestedAt: String,
    hits: prop([Object]).default([]).fromJs(searchHitFromJs),
    query: prop(SearchQuery).isRequired,
    aggregations: SearchAggregations,
    isLoading: prop(Boolean).default(false), // whether the search results are loading or returned
  },

  statics: {
    create(attrs) {
      let defaults = {
        id: this.newId(),
        requestedAt: ServerClock.toISOString(),
      };

      return new this(_.merge(defaults, attrs));
    },

    createWithSearchText(text) {
      return this.create({
        query: new SearchQuery({ text }),
      });
    },

    newId() {
      return IdGenerator.newId();
    },

    HitTypes,
  },
});

export const MAX_RESULT_INDEX = 10000;
